import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { ThemeSwitch } from '@/components/theme-switch'
import { NewsroomAlertsPanel } from './components/NewsroomAlertsPanel'
import { NewsroomDismissAlertDialog } from './components/NewsroomDismissAlertDialog'
import { NewsroomEmptyState } from './components/NewsroomEmptyState'
import { NewsroomLoadMoreButton } from './components/NewsroomLoadMoreButton'
import { NewsroomLoadingState } from './components/NewsroomLoadingState'
import { NewsroomPageToolbar } from './components/NewsroomPageToolbar'
import { useNewsroomPageState } from './hooks/useNewsroomPageState'

export function NewsroomPage() {
  const {
    settingsOpen,
    setSettingsOpen,
    includeDismissed,
    setIncludeDismissed,
    selectedAlertId,
    dismissTargetId,
    alerts,
    selectedAlert,
    alertsQuery,
    markRead,
    handleSelectAlert,
    handleRequestDismiss,
    handleDismissDialogOpenChange,
    handleConfirmDismiss,
    handleMarkRead,
    isLoading,
    showEmptyNoSubscriptions,
    showEmptyNoAlerts,
    showAlertsPanel,
  } = useNewsroomPageState()

  return (
    <>
      <Header fixed>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>
      <Main className='flex flex-1 flex-col gap-4'>
        <NewsroomPageToolbar
          settingsOpen={settingsOpen}
          onSettingsOpenChange={setSettingsOpen}
          includeDismissed={includeDismissed}
          onIncludeDismissedChange={setIncludeDismissed}
        />

        {isLoading ? <NewsroomLoadingState /> : null}

        {showEmptyNoSubscriptions ? (
          <NewsroomEmptyState
            variant='noSubscriptions'
            onOpenSettings={() => {
              setSettingsOpen(true)
            }}
          />
        ) : null}

        {showEmptyNoAlerts ? (
          <NewsroomEmptyState variant='noAlerts' />
        ) : null}

        {showAlertsPanel ? (
          <NewsroomAlertsPanel
            alerts={alerts}
            selectedAlert={selectedAlert}
            selectedAlertId={selectedAlertId}
            isMarkReadPending={markRead.isPending}
            onSelectAlert={handleSelectAlert}
            onMarkRead={handleMarkRead}
            onRequestDismiss={handleRequestDismiss}
          />
        ) : null}

        <NewsroomLoadMoreButton
          hasNextPage={alertsQuery.hasNextPage}
          isFetchingNextPage={alertsQuery.isFetchingNextPage}
          onLoadMore={() => {
            void alertsQuery.fetchNextPage()
          }}
        />
      </Main>

      <NewsroomDismissAlertDialog
        open={dismissTargetId !== null}
        onOpenChange={handleDismissDialogOpenChange}
        onConfirm={handleConfirmDismiss}
      />
    </>
  )
}
